<template>
  <el-dialog title="搜索异常" :visible.sync="visible" width="600px" @close="close">
    <WmsTable :columns="columns" :isPagination="false" :dataSource="list">
      <template #text="{record}">
        <div>
          {{ record.text }}
        </div>
      </template>
      <template #error>
        <div>
          物流单号不存在或者不满足搜索条件
        </div>
      </template>
    </WmsTable>

  </el-dialog>
</template>
<script>
import WmsTable from "@/components/WmsTable";
export default {
  name: 'errorModal',
  components: {
    WmsTable
  },
  data() {
    return {
      visible:false,
      list: [],
      columns: [
        {
          title: "物流单号",
          dataIndex: "text",
          scopedSlots: {
            customRender: 'text'
          }
        },
        {
          title: "异常原因",
          dataIndex: "error",
          scopedSlots: {
            customRender: 'error'
          }
        },
      ]
    }
  },
  methods: {
    open(v) {
      this.list = v.map(v => ({text:v}))
      this.visible = true
    },
    close() {
      this.visible = false

    },
    ok() {

    }
  }
}
</script>
